<template lang="pug">
  v-dialog(v-model="show" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable max-width="900"  persistent)
    v-snackbar(v-model="showSnackBar" :timeout="5000" :color="snackBarColor" )
      | {{ snackBarText }}
      v-btn(fab text @click="showSnackBar = false")
        v-icon fal fa-times-circle
    DetailImageDialog(
      v-if="showDetailImageDialog"
      :show="showDetailImageDialog"
      :selectedFoodName="selectedItem.name"
      :foodImageList="selectedItem.media"
      :index="indexItem"
      @close="onCloseDetailImageClick"
    )
    v-card(v-if="!fetchInProgress" height="680px")
      v-card-title.text-break {{selectedItem.name}}
        v-tabs(v-model="tab")
          v-tab(v-if="selectedItem.media.length") {{ $t('orderPage.imagesLabel') }}
          v-tab {{ $t('orderPage.allergensTitle') }}
      v-card-text.pa-0
        v-tabs-items(v-model="tab" touchless)
          v-tab-item(v-if="selectedItem.media.length")
            v-card.elevation-0
              v-card-text(v-if="$vuetify.breakpoint.mdAndUp")
                v-row.ma-0
                  v-col(md="4" v-for="(i, idx) in selectedItem.media", :key="idx")
                    v-img.elevation-1(:src="getImage(i)" :lazy-src="getImage(i)" height="230px" @click="onDetailImageClick(idx)" out)
                      template( v-slot:placeholder)
                        v-row.ma-0(class="fill-height ma-0" align="center" justify="center" v-if="!fetchInProgress")
                          v-progress-circular(indeterminate color="primary")
              v-card-text(v-else )
                v-row.ma-0
                  v-col(cols="12" sm="6" v-for="(i, idx) in selectedItem.media", :key="idx" )
                    v-img.elevation-1(:src="getImage(i)" height="230px" :lazy-src="getImage(i)"  @click="onDetailImageClick(idx)")
                      template( v-slot:placeholder)
                        v-row.ma-0(class="fill-height ma-0" align="center" justify="center" v-if="!fetchInProgress")
                          v-progress-circular(indeterminate color="primary")
          v-tab-item
            v-list(disabled)
              v-list-item(dense v-for="(item, idx) in allergensList", :key="idx" )
                v-list-item-avatar.ma-0(size="30" :class="getAllergenClass(item.code)") {{item.code}}.
                v-list-item-title.text-wrap(:class="getAllergenClass(item.code)") {{item.title}}
      v-divider
      v-card-actions
        v-spacer
        v-btn(text color="primary" @click="onCloseDialogClick") {{ $t('dashboardPage.closeButtonLabel') }}
    v-skeleton-loader(v-else type="list-item-three-line@7")

</template>

<script lang="ts">
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import Allergen from "@/model/Allergen";
import {FETCH_ALLERGEN_LIST, FETCH_FOOD_ITEM_IMAGES} from "@/store/action-types";
import {TranslateResult} from "vue-i18n";
import AllergenDetail from "@/model/AllergenDetail";
import {Action} from "vuex-class";
import DetailImageDialog from "@/components/order/DetailImageDialog.vue";

@Component({
  components: {
    DetailImageDialog
  }
})
export default class InfoMenuGroupItemDialog extends Vue {
  @Prop({type: Boolean, default: false}) readonly show!: boolean
  @Prop({type: Object, required: true}) readonly selectedItem!: AllergenDetail
  @Action(FETCH_FOOD_ITEM_IMAGES) fetchFoodItemImageList!: ({ (payload: any): Promise<any> })

  private fetchInProgress = false
  private allergensList: Allergen[] | null = []
  private showSnackBar: boolean = false
  private snackBarText: TranslateResult | string = ''
  private snackBarColor: string = ''
  private tab: number | null = null
  private showDetailImageDialog: boolean = false
  private indexItem: number | null = null

  getImage (item: any): any {
    return `/api/food-database/food-item-media/${item.id}/data`
  }

  getAllergenClass (item: string): string {
    if(this.selectedItem.allergens.find((i: Allergen) => i.code === item)) {
      return 'text-allergen-style'
    } else {
      return 'text-style'
    }
  }

  onCloseDialogClick () {
    this.$emit('close')
  }

  onDetailImageClick(item: number): void {
    this.showDetailImageDialog = true
    this.indexItem = item
  }

  onCloseDetailImageClick(): void {
    this.showDetailImageDialog = false
  }

  async fetchAllergens ():Promise<void> {
    this.fetchInProgress = true
    try{
      this.allergensList = await this.$store.dispatch(FETCH_ALLERGEN_LIST)
    }catch (e) {
      this.snackBarColor = 'error'
      this.snackBarText = this.$t('errors.fetchDataError')
      this.showSnackBar = true
    }finally {
      this.fetchInProgress = false
    }
  }

  mounted(): void {
    this.fetchAllergens()
  }

}
</script>

<style lang="stylus" scoped>
.text-style
  color lightgrey
  margin-top 0
  margin-bottom 0

.text-allergen-style
  color black

.guiding-image
  height 200px

.title-style
  color red

.v-list--dense .v-list-item, .v-list-item--dense {
  min-height: 30px;
}
</style>
